export default "__VITE_ASSET__BSQgHDI3__"